import { TECH_LOGOS } from "@/assets/static/images";
import Tech from "@/types/Tech";

// Curated tech stack - Only core competencies and actively used technologies
// Following portfolio best practices: focus on what makes you hireable, not everything you've touched
export const TECH: Tech[] = [
    // Core Languages - What you code in daily
    { id: "typescript", name: "TypeScript", logo: TECH_LOGOS.typescript },
    { id: "kotlin", name: "Kotlin", logo: TECH_LOGOS.kotlin },
    { id: "java", name: "Java", logo: TECH_LOGOS.java },

    // Frontend - Modern web development
    { id: "react", name: "React", logo: TECH_LOGOS.react },
    { id: "nextjs", name: "Next.js" },
    { id: "scss", name: "SCSS", logo: TECH_LOGOS.sass },
    { id: "html5", name: "HTML5", logo: TECH_LOGOS.html5 },
    { id: "javascript", name: "JavaScript", logo: TECH_LOGOS.javascript },
    { id: "tailwind", name: "Tailwind CSS", logo: TECH_LOGOS.tailwind },

    // Android - Mobile expertise
    { id: "jetpack-compose", name: "Jetpack Compose" },
    { id: "android-architecture", name: "Modern Android Architecture (MVVM/Clean)" },
    { id: "coroutines-flow", name: "Coroutines & Flow" },

    // Backend - Server-side capabilities
    { id: "spring-boot", name: "Spring Boot" },
    { id: "ktor", name: "Ktor" },
    { id: "koin", name: "Koin" },
    { id: "nodejs", name: "Node.js", logo: TECH_LOGOS.nodejs },
    { id: "rest-api", name: "REST APIs" },

    // Data Layer - Database and caching
    { id: "postgresql", name: "PostgreSQL" },
    { id: "redis", name: "Redis", logo: TECH_LOGOS.redis },
    { id: "prisma", name: "Prisma ORM" },
    { id: "mongodb", name: "MongoDB", logo: TECH_LOGOS.mongodb },

    // DevOps & Tools - Deployment and automation
    { id: "docker", name: "Docker" },
    { id: "cicd", name: "CI/CD Pipelines" },
    { id: "git", name: "Git", logo: TECH_LOGOS.git },
    { id: "github", name: "GitHub", logo: TECH_LOGOS.github },
    { id: "npm", name: "npm", logo: TECH_LOGOS.npm },
    { id: "prettier", name: "Prettier", logo: TECH_LOGOS.prettier },
    { id: "sentry", name: "Sentry", logo: TECH_LOGOS.sentry },
    { id: "ubuntu", name: "Ubuntu", logo: TECH_LOGOS.ubuntu },

    // Specialized - Unique capabilities that set you apart
    { id: "websocket", name: "WebSocket & Real-Time" },
    { id: "i18n", name: "Internationalization" },
    { id: "bluetooth", name: "Bluetooth Integration" },
    { id: "system-design", name: "System Design" },
    { id: "webassembly", name: "WebAssembly", logo: TECH_LOGOS.webassembly },
];
